import React from 'react';
import {
    DocumentPreviewProvider,
    DossierFormulaireProvider,
    DossierRoutingProvider,
    dossiersBasePath,
    Layout,
    LAYOUT_DEFAULT,
    LAYOUT_DOCUMENTS,
    LAYOUT_DOCUMENTS_1_3,
    LAYOUT_DOCUMENTS_FULL,
    LAYOUT_FORMS_FULL,
    TypeDocumentsProvider,
    useCurrentDossierCtx,
} from '@europrocurement/l2d-modules';
import { DossierInfoBodyValidation } from '../../components';

import { ordersBasePath } from '../../../Orders';

const getLayout = (): Layout => {
    const layouts = [
        LAYOUT_DEFAULT,
        LAYOUT_DOCUMENTS,
        LAYOUT_DOCUMENTS_FULL,
        LAYOUT_DOCUMENTS_1_3,
        LAYOUT_FORMS_FULL,
    ];
    const params = new URLSearchParams(document.location.search);

    if (params.has('layout') && layouts.includes(params.get('layout') as string)) {
        return params.get('layout') as Layout;
    }

    return LAYOUT_DEFAULT;
};

const DossierInfoValidation: React.FunctionComponent = function () {
    const layout = getLayout();
    const { dossier } = useCurrentDossierCtx();

    if (!dossier) {
        return null;
    }

    return (
        <DossierRoutingProvider
            orderBasePath={ordersBasePath}
            dossierBasePath={dossiersBasePath}
        >
            <DossierFormulaireProvider idDossiers={[dossier.id] as number[]}>
                <TypeDocumentsProvider autoload>
                    <DocumentPreviewProvider>
                        <DossierInfoBodyValidation layout={layout} />
                    </DocumentPreviewProvider>
                </TypeDocumentsProvider>
            </DossierFormulaireProvider>
        </DossierRoutingProvider>
    );
};

export default DossierInfoValidation;
